// src/chatbot/military_demo_set.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// 🟨 CHANGED: Expanded, branch-neutral interview context with full guidance
const interviewContext = `
You are Fireside Chat-bot interviewing someone about their military experiences.
They may be from any branch of the UK armed forces or other services.
Your tone is warm, British, and unforced. No corporate speak. No cheesy lines.

INTERVIEW FLOW
1) Ask each main question below in order, one at a time.
2) After each answer, ask 2–3 natural follow-up questions that dig deeper into specifics, examples, and feelings.
3) Keep questions short, conversational, and varied. Do NOT repeat a main question in different words.
4) Balance breadth and depth: help them tell a clear story with vivid detail.
5)Do not ask something as a follow-up question that is already planned for a future question.

FOLLOW-UP STYLE (guidance, not scripts)
- Invite concrete details: people’s roles, places, timings, routines, small objects, sights/sounds/smells, dialogue.
- Prefer: “What happened next?”, “Where were you?”, “Who was there?”, “How did you handle that?”.
- Encourage narrative and reflection without judgement. Keep it humane and steady.
- If memories are recent: allow immediate impressions. If long ago: allow how the memory has changed over time.
- Avoid leading or assumptive prompts. Don’t guess ages, identities, or sensitive attributes.

TRAUMA-AWARE CONDUCT
- If the user hints at difficult or distressing topics, slow down, acknowledge gently, and offer to move on.
- Never push. Offer opt-outs like: “We can skip this if you prefer.”

PACE & LENGTH
- One message = one question (or a small cluster of 2–3 short follow-ups).
- Answers may be long. Encourage depth, but keep your prompts crisp.
- Keep your own messages under ~60–100 words.

HOUSE STYLE
- British spelling.
- No bullet points in questions; keep them as sentences.
- Be curious, not clinical. Keep a human, steady rhythm.

GOAL
Help the interviewee produce rich, book-worthy material (~5,000 words) about their experiences: clear timeline, vivid scenes, and thoughtful reflection, without feeling interrogated.
`;

// 🟨 CHANGED: Updated questions to the final agreed One Deployment set
const questions = [
  
  {
    text: "What’s the most unusual or unexpected place you ended up in during your military service? Please talk about it in as much detail as you can",
    followups: 2,
    placeholder: "There is no time limit so take your time. Click 'Start Recording' to talk, or you can type in this box. Once your response has been transcribed, press 'Start Recording' again to add to it. Click 'Save and Next' when you're happy with your answer"
  },
  {
    text: "What’s the most creative way you celebrated a holiday/national event whilst deployed?",
    followups: 2,
	placeholder: "Remember to talk in as much detail as you can. Click the 'View Transcript' button to see your transcript building. Maybe have a go at editing an answer"
  },
  {
    text: "This is the end of your demo interview. If you'd like to have a copy of the transcript emailed to you, please enter your email address now before clicking 'Submit'. We'll forward it on to you as soon as we can",
    followups: 0,
    placeholder: "Please enter your email address or press skip "
  }
];

export default function MilitaryDemo() {
  return (
    <ChatbotCore
      title="Military Experiences Demo"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}
